import concat from 'lodash/concat';

import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';
import { VIRTUAL_VISIT_TYPES } from '../virtual-visit';
import * as statusChange from './status-change-req';
import * as cancelInvitation from './cancel-invitation-to-virtual-room-req';

export const consts = createReqConsts('health-board', 'invite-quest', ['INIT']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'post',
  slug: ['virtual_visits', 'room_invitation'],
});

const defaultRequestReducer = createReqReducer(consts);

const initialState = {
  temp: [],
  existing: [],
  appointmentId: null,
  send: {
    sending: false,
    succeed: null,
    error: null,
  },
  cancel: {
    sending: false,
    succeed: null,
    error: null,
  },
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case statusChange.consts.SUCCEED: {
      return {
        ...state,
        appointmentId: payload.id,
      };
    }

    case consts.SEND: {
      return {
        ...state,
        temp: payload.guests.map(el => el.email || el.phoneNumber) || [],
        send: {
          ...state.send,
          error: null,
          sending: true,
        },
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        temp: [],
        existing: concat(state.existing, state.temp),
        send: {
          ...state.send,
          succeed: true,
          sending: false,
        },
      };
    }

    case consts.REJECTED:
    case consts.ERROR_ENCOUNTERED: {
      return {
        ...state,
        send: {
          ...state.send,
          sending: false,
          error: payload,
        },
      };
    }

    case consts.CLEAR: {
      return {
        appointmentId: state.appointmentId,
        ...initialState,
      };
    }

    case cancelInvitation.consts.SEND: {
      return {
        ...state,
        cancel: {
          ...state.cancel,
          sending: true,
        },
      };
    }

    case cancelInvitation.consts.SUCCEED: {
      return {
        ...state,
        cancel: {
          ...state.cancel,
          succeed: true,
          sending: false,
        },
      };
    }

    case cancelInvitation.consts.REJECTED:
    case cancelInvitation.consts.ERROR_ENCOUNTERED: {
      return {
        ...state,
        cancel: {
          ...state.cancel,
          sending: false,
          error: payload,
        },
      };
    }

    case VIRTUAL_VISIT_TYPES.RESET: {
      return {
        ...initialState,
      };
    }

    default: {
      return defaultRequestReducer(state, action);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/invite-guest-to-virtual-room-req.js